<template>
  <v-container id="contratosform" tag="section">
    <base-v-component :heading="contratosHeading" />
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn color="primary" @click="save" :loading="loadingForm"
          >Generar Contrato
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container grid-list-md>
          <v-row align="center">
            <v-col cols="12" sm="6" md="4">
              <v-text-field v-model="contrato.nombre" label="Nombre contrato" />
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                chips
                clearable
                v-model="clienteSelect"
                label="Clientes"
                :items="clientesSelect"
              />
            </v-col>
            <!-- <v-col cols="12" sm="6" md="4">
              <v-select
                v-model="contrato.tipo"
                :items="[
                  {
                    text: 'Desde plantilla',
                    value: 'plantilla',
                  },
                  {
                    text: 'Desde fichero',
                    value: 'fichero',
                  },
                ]"
                label="Tipo contrato"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" v-if="contrato.tipo == 'plantilla'">
              <v-select
                v-model="contrato.plantilla"
                item-text="nombre"
                item-value="id"
                :items="plantillas"
                label="Plantilla contrato"
                @change="cambiarPlantilla"
              />

            </v-col> -->
          </v-row>
          <v-row>
            <v-col cols="12" sm="10" md="8">
              <h4 class="text-h4">Ficheros</h4>
              <v-file-input
                chips
                multiple
                counter
                v-model="contrato.ficheros"
                label="Contratos en PDF"
              ></v-file-input
            ></v-col>
          </v-row>
          <!-- <v-row>

            <v-col cols="12" sm="6">
              <v-card>
                <v-card-title>Variables</v-card-title>
                <v-card-text>
                  <v-row wrap>
                    <v-col
                      cols="6"
                      v-for="(v, i) in contrato.variables"
                      :key="i"
                      dense
                    >
                      <v-text-field
                        dense
                        outlined
                        v-model="v.valor"
                        :label="`valor de ${v.variable}`"
                      /> </v-col
                  ></v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6">
              <v-card>
                <v-card-title>Datos Cliente</v-card-title>
                <v-card-text>
                  <v-row wrap>
                    <v-col cols="12">
                      <v-tooltip
                        top
                        v-for="(c, i) in datosClienteUsar"
                        :key="i"
                      >
                        <template v-slot:activator="{ on }">
                          <v-chip class="ma-2" v-on="on">{{ c.texto }} </v-chip>
                        </template>
                        <span>{{ c.valor }}</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row> -->
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
      </v-card-actions>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      loadingForm: false,
      clienteSelect: null,
      contrato: {
        id: null,
        modo: "",
        negocio: "",
        estado: "borrador", //borrador,generado,esperando firma,firmado
        nombre: "",
        cliente: "",
        ficheros: [],
        visible: false,
      },
    };
  },
  computed: {
    modoComputado() {
      var found = this.clientesSelect.find(
        (c) => c.value === this.contrato.cliente
      );
      if (found) {
        return found.modo;
      }
    },
    datosClienteUsar() {
      var found = this.$store.state.app.clientesFacturar.find(
        (c) => c.id === this.contrato.cliente
      );
      if (found) {
        return Object.keys(found).map((k) => {
          return {
            texto: k,
            valor: found[k],
          };
        });
      }
    },
    contratosHeading() {
      return this.contrato.id
        ? "Ver contrato " + this.contrato.id
        : "Nuevo contrato";
    },
    ...mapState({
      idiomas: "idiomas",
      langDefecto: "langDefecto",
      plantillas: (state) => state.contratos.plantillas,
    }),
    ...mapGetters({
      clientesSelectBruto: "app/clientesFacturarSelect",
    }),
    clientesSelect() {
      return [
        ...this.clientesSelectBruto,
        ...this.$store.state.partners.partners.map((p) => {
          let aux = {
            id: p.id,
            negocio: p.id,
            modo: "partner",
          };
          return {
            text: p.nombre + " | " + " Partner",
            value: aux,
          };
        }),
      ];
    },
    goEliminar(item) {
      console.log(item);
      let _vm = this;
      var confirm = false;
      this.$confirm(
        "¿Desea eliminar el contrato? Esta acción es irreversible?",
        {
          buttonTrueText: "Aceptar",
          buttonFalseText: "No",
          color: "warning",
          icon: "warning",
          width: 350,
        }
      )
        .then((r) => {
          if (r) {
            confirm = true;
            item.loadingEliminar = true;
            return this.$store.dispatch("contratos/eliminarContrato", item.id);
          }
        })
        .then(() => {
          if (confirm) {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Plantilla eliminada",
            });
          }
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "No se ha podido eliminar la plantilla " + e,
          });
        })
        .finally(() => {
          item.loadingEliminar = false;
          _vm.reload();
        });
    },
  },
  methods: {
    save() {
      let _vm = this;
      this.contrato.modo = this.clienteSelect.modo;
      this.contrato.cliente = this.clienteSelect.id;
      this.contrato.negocio = this.clienteSelect.negocio;
      _vm.loadingForm = true;

      this.$store
        .dispatch("contratos/generarContrato", this.contrato)
        .then((res) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Contrato generado",
          });
          _vm.$router.push("/admin/contratos");
        })
        .catch((error) => {
          console.log(error);
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al generar el contrato",
          });
        })
        .finally(() => {
          _vm.loadingForm = false;
        });
    },
    cambiarPlantilla() {
      let found = this.plantillas.find((p) => p.id === this.contrato.plantilla);
      if (found) {
        this.contrato.variables = found.variables
          ? found.variables.map((v) => {
              return {
                variable: v,
                valor: "",
              };
            })
          : [];
      } else {
        this.contrato.variables = [];
      }
    },
    goListado() {
      let str = "/admin/contratos/";
      this.$router.push(str);
    },
  },
  created() {},
  mounted() {
    this.$store.dispatch("app/getClientesFacturar");
    this.$store.dispatch("contratos/getPlantillas");
    this.$store.dispatch("partners/getPartners");
    this.id = this.$route.params.id;
    var _vm = this;
    if (this.id) {
      this.$store
        .dispatch("pedidos/getContrato", this.id)
        .then((r) => {})
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: e,
          });
          _vm.goListado();
        });
    } else {
    }
  },
};
</script>

<style>
</style>